export * from '@fhs/routing/src/routes/(drawer)/diagnostics';
export { default } from '@fhs/routing/src/routes/(drawer)/diagnostics';
